import React, { Component } from 'react';
import Layout from '../Layout';
import { connect } from 'react-redux';
import Paper from 'material-ui/Paper';
import { withStyles } from 'material-ui/styles';
import { LinearProgress } from 'material-ui';
import Icon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { fade } from '@material-ui/core/styles/colorManipulator';
import { TableCell } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { PagingState, IntegratedPaging, SortingState, IntegratedSorting } from '@devexpress/dx-react-grid';
import { Grid, PagingPanel, Table, TableHeaderRow, TableColumnResizing } from '@devexpress/dx-react-grid-material-ui';
import { API, graphqlOperation } from 'aws-amplify';
import { getSubmissions } from '../../graphql/queries';
import DataTestSubmission from './DataTestSubmission';
import deleteSubmission from '../../graphql/mutations';
import RenderDialog from '../../helpers/RenderDialog';
import postCreatePresignedUrl from '../../actions/postCreatePresignedUrl';
import getEnvironmentFromUrl from '../../helpers/GetEnvironment';
import ProgressBar from '../SimpleProcessBar';

const styles = theme => ({
  paperStyle: {
    width: '70%',
    height: '70%',
    display: 'inline-block',
    marginTop: '5.4vh',
    maxWidth: '1075px',
    //height: '690px',
    padding: '0px 30px 0px 30px'
  },
  table: {
    minWidth: '650px',
  },
  linearProgress: {
    borderTopLeftRadius: '4px',
    borderTopRightRadius: '4px',
  },
  addIcon: {
    color: 'white',
    background: 'rgba(0, 0, 0, 0.54)',
    borderRadius: '40px',
    width: '25px',
    height: '25px',
    boxShadow: '1px 2px 6px rgba(0, 0, 0, 0.24), inset 0px 1px 0px rgba(255, 255, 255, 0.12)'
  },
  boxTop: {
    height: '70px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end'
  },
  tableStriped: {
    '& tbody tr:nth-of-type(odd)': {
      backgroundColor: fade('rgba(125, 121, 121)', 0.05),
    },
  },
  cell: {
    textAlign: 'center',
    fontSize: '16px',
    color: '#757575',
    fontWeight: '200'
  },
  headRow: {
    textAlign: 'center',
    fontSize: '16px !important',
    color: '#162129 !important',
    paddingLeft: '28px !important',
  },
  deleteCell: {
    textAlign: 'center',
    fontSize: '14px',
    color: 'gray',
    width: '30px',
  },
  fileLink: {
    color: '#0000EE',
    textDecoration: 'underline'
  }
});

const sortByDate = (a, b) => {
  let dateA = new Date(a);
  let dateB = new Date(b);

    if (dateA > dateB) {
      return 1;
    }
    else if (dateB > dateA) {
      return -1;
    }
      return 0;
}

const sortByStatus = (a, b) => {
  let statusA = a.props.children[1];
  let statusB = b.props.children[1];

  if (statusA > statusB) {
    return 1;
  } else if (statusB > statusA) {
    return -1;
  }
    return 0;
}

const sortByProcessingInfo = (a, b) => {
  let processingA = a;
  let processingB = b;

  if (a.props && b.props) {
    processingA = a.props.children;
    processingB = b.props.children;
  }

  if (processingA > processingB) {
    return 1;
  } else if (processingB > processingA) {
    return -1;
  } else {
    return 0;
  }
}

const sortByName = (a, b) => {
  a = a.toLowerCase();
  b = b.toLowerCase();

  if (a > b) {
    return 1;
  } else if (b > a) {
    return 1;
  } else {
    return 0;
  }
}

class DataTestTool extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [
        { name: 'fileName', title: 'File' },
        { name: 'date', title: 'Date' },
        { name: 'personName', title: 'User' },
        { name: 'status', title: 'Status' },
        { name: 'processingInformation', title: 'Processing Information' },
        { name: 'deleteReport', title: ' ' }
      ],
      submissionRows: [],
      isFetching: true,
      errorMessage: '',
      openDialog: false,
      confirmDelete: false,
      rowToDelete: {},
      integratedSorting: [
        { columnName: 'date', compare: sortByDate },
        { columnName: 'status', compare: sortByStatus },
        { columnName: 'processingInformation', compare: sortByProcessingInfo },
        { columnName: 'personName', compare: sortByName }
      ],
      showSubmissionScreen: false,
      columnWidth: [
        { columnName: 'fileName', width: 205 },
        { columnName: 'date', width: 155 },
        { columnName: 'personName', width: 200 },
        { columnName: 'status', width: 100 },
        { columnName: 'processingInformation', width: 360 },
        { columnName: 'deleteReport', width: 20 }
      ],
    };

    this.changeSorting = sorting => this.setState({ sorting });
    this.onDelete = this.onDelete.bind(this);
  }

  async componentDidMount() {
    this.updateSubmissions();
    setInterval(() => {this.updateSubmissions();}, 60000);
  }

  updateSubmissions = async () => {
    const { data } = this.props;
    let allSubmissions = {};

    try {
      allSubmissions = await API.graphql(
        graphqlOperation(getSubmissions(`personId: "${data.person.personId}"`))
      );

    } catch (error) {
      this.setState({
        errorMessage: 'An error occured while loading the submissions. Please try again.',
        openDialog: true
      });
    }

    let submissionRows = this.formatRows(allSubmissions.data.getSubmissions);

    this.setState({
      submissionRows: submissionRows,
      isFetching: false,
    });
  }

  formatRows = (submissions) => {
    let rows = submissions.map(row => ({
      ...row,
      id: row.datetime,
      fileName: this.renderFileName(row.submissionKey),
      date: this.getDate(row.datetime),
      personName: row.personName,
      status: this.getStatus(row.status),
      processingInformation: this.getResult(row.result),
    }));

    return rows;
  }

  renderFileName = (fileLocation) => {
    let fileName = '';

    if (fileLocation !== null) {
      let fileNameArray = fileLocation.split('/');
      let tempFileName = fileNameArray[2];
      let newFileName = tempFileName.split('_');

      if (newFileName.length > 1) {
        let fileExtension = newFileName[1].substring(0, 2);
        fileName = `${newFileName[0]}.${fileExtension}`.toLowerCase();
      } else {
        fileName = newFileName;
      }
    }

    return fileName;
  }

  getDate = (datetime) => {
    let date = new Date(datetime);

    let day = date.getDate();
    let month = date.getMonth();
    let year = date.getFullYear();
    let hour = date.getHours();
    let minutes = date.getMinutes()

    return `${month + 1}/${day}/${year} ${hour}:${minutes}`;
  }

  getStatus = (status, datetime) => {
    let statusCell = <div />;

    if (status === 'Pending') {
      statusCell = (<ProgressBar bgColor="#07e9f5" fgColor="white" status="100" message="Pending" />);
    } else if (status === 'Error') {
      statusCell = (<ProgressBar bgColor="#e30b16" fgColor="white" status="100" message="Error" />);
    } else if ((status === 'Completed' || status === '100') || (status > 100)) {
      statusCell = (<ProgressBar bgColor="#098ce3" fgColor="white" status="100" message="Completed" />);
    } else {
      statusCell = (<ProgressBar bgColor="#6bd90b" fgColor="#000000" status={status} message={`${status}%`} />);
    }

    return statusCell;
  }

  getResult = (result) => {
    if (result && result.includes('results/')) {
      return this.renderLink(result);
    } else if (result === null) {
      return '' // convert to empty string so it sorts
    } else {
      return result.toLowerCase();
    }
  }

  renderLink = (fileLocation) => {
    const { classes } = this.props;
    let fileLink = <div />;

    if (fileLocation !== null) {
      let fileNameArray = fileLocation.split('/');
      let tempFileName = fileNameArray[3];
      let newFileName = tempFileName.split('_');
      let vhrFileName = 'vehicle_history_results.zip';
      let ownershipFileName = 'vehicle_ownership_history_results.zip';
      let riskFileName = 'risk_score_results.zip';
      let vhrDisplayName = 'vhr_results.zip';
      let ownershipDisplayName = 'ownership_results.zip';
      let riskDisplayName = 'risk_results.zip';
      let vhrFileLocation = fileLocation.replace('results.zip', vhrFileName);
      let ownershipFileLocation = fileLocation.replace('results.zip', ownershipFileName);
      let riskFileLocation = fileLocation.replace('results.zip', riskFileName);

      fileLink = (
          <div>
            <div>
              <a className={`${classes.fileLink} hover-close`} onClick={() => this.props.actions.getFileLink(fileLocation, this.props.data.config, this)} target="_blank" rel="noopener noreferrer">{newFileName}</a>
            </div>
          </div>
      );
    }

    /* if you have json output
    fileLink = (
        <div>
          <div>
            <a className={`${classes.fileLink} hover-close`} onClick={() => this.props.actions.getFileLink(fileLocation, this.props.data.config, this)} target="_blank" rel="noopener noreferrer">{newFileName}</a>
            <span style={{width: '5px'}}>&nbsp;</span>
            <a className={`${classes.fileLink} hover-close`} onClick={() => this.props.actions.getFileLink(vhrFileLocation, this.props.data.config, this)} target="_blank" rel="noopener noreferrer">{vhrDisplayName}</a>
          </div>
          <div>
            <a className={`${classes.fileLink} hover-close`} onClick={() => this.props.actions.getFileLink(riskFileLocation, this.props.data.config, this)} target="_blank" rel="noopener noreferrer">{riskDisplayName}</a>
            <span style={{width: '5px'}}>&nbsp;</span>
            <a className={`${classes.fileLink} hover-close`} onClick={() => this.props.actions.getFileLink(ownershipFileLocation, this.props.data.config, this)} target="_blank" rel="noopener noreferrer">{ownershipDisplayName}</a>
          </div>
        </div>
    );
    */

    return fileLink;
  }

  handleClose = () => {
    this.setState({ openDialog: false });
  }

  onDelete = (id, event) => {
    event.preventDefault();

    const { submissionRows } = this.state;
    let rowToDelete = submissionRows.filter(row => row.id == id);

    this.setState({
      confirmDelete: true,
      errorMessage: 'Are you sure you want to delete this submission?',
      rowToDelete: rowToDelete
    })
  }

  confirmDelete = () => {
    const { submissionRows, rowToDelete } = this.state;

    let updatedRows = submissionRows.filter(row => row.id !== rowToDelete[0].id);

    try {
      (async () => {
        await API.graphql(graphqlOperation(
          deleteSubmission,
          { personId: rowToDelete[0].personId, datetime: rowToDelete[0].datetime }
        ));
        await this.setState({
          confirmDelete: false,
          ...submissionRows, submissionRows: updatedRows,
          rowToDelete: {},
        });
      })();
    } catch (error) {
        this.setState({
          errorMessage: 'An error occured while deleting the submission. Please try again.',
          openDialog: true
        });
    }
  }

  cancelDelete = () => {
    this.setState({ confirmDelete: false })
  }

  TableComponent = (tableProps) => {
    const { classes } = this.props;

    return <Table.Table
      {...tableProps}
      className={classes.tableStriped}
    />;
  };

  CellComponent = (cellProps) => {
    const { classes } = this.props;
    const { column, row } = cellProps;

    if (column.name === 'deleteReport') {
      return (
        <TableCell {...cellProps} className={classes.deleteCell}>
          <IconButton onClick={(event) => this.onDelete(row.id, event)}>
            <DeleteIcon />
          </IconButton>
        </TableCell>
      )
    }

    return <Table.Cell
      {...cellProps}
      className={classes.cell}
    />;
  };

  TableHeadCell = (cellProps) => {
    const { classes } = this.props;

    return <TableHeaderRow.Cell
      {...cellProps}
      className={classes.headRow}
    />
  }

  render() {
    const { classes } = this.props;
    const { openDialog,
      errorMessage,
      isFetching,
      submissionRows,
      columns,
      showSubmissionScreen,
      columnWidth,
      confirmDelete,
      integratedSorting
    } = this.state;

    const dialog = (
      <RenderDialog
        open={openDialog}
        confirmButton
        message={errorMessage}
        onClose={this.handleClose}
      />
    );

    const deleteConfirmation = (
      <RenderDialog
        open={confirmDelete}
        message={errorMessage}
        onAgree={this.confirmDelete}
        onClose={this.cancelDelete}
        showActions
      />
    );

    const submissionsTable = (
      <Grid
        rows={submissionRows}
        columns={columns}
      >
        <PagingState
          defaultCurrentPage={0}
          pageSize={9}
        />
        <IntegratedPaging />
        <SortingState
          defaultSorting={[{ columnName: 'date', direction: 'desc' }]}
        />
        <IntegratedSorting
          columnExtensions={integratedSorting}
        />
        <Table
          cellComponent={this.CellComponent}
          tableComponent={this.TableComponent}
        />
        <TableColumnResizing defaultColumnWidths={columnWidth} />
        <TableHeaderRow
          showSortingControls
          cellComponent={this.TableHeadCell}
        />
        <PagingPanel />
      </Grid>
    );

    const mainScreen = (
      <Paper className={classes.paperStyle}>
        {isFetching && <LinearProgress className={classes.linearProgress} />}
        <div className={classes.boxTop}>
          <IconButton onClick={() => this.setState({ showSubmissionScreen: true })}>
            <Icon
              color="action"
              className={`hover-close ${classes.addIcon}`}
            />
          </IconButton>
        </div>
        {errorMessage && dialog}
        {confirmDelete && deleteConfirmation}
        {submissionsTable}
        </Paper>
    );

    const submissionScreen = (
      <DataTestSubmission
        handleRedirect={() => this.setState({ showSubmissionScreen: false })}
      />
    );

    return (
      <Layout
        className='App'
        showMenu
        menuTitle='Data Test Tool'
        leftTitle='Data Test Tool'
        toolTip='Having problems? Please review the information you have entered to be sure everything is correct.  If you continue to have problems please contact our Customer Service department at (205) 414-2727.'
      >
        {showSubmissionScreen ? submissionScreen : mainScreen}
      </Layout>
    );
  }
}

const mapStateToProps = state => ({
  data: {
    config: state.config.config,
    person: state.person.person,
  }
});

const mapDispatchToProps = dispatch => ({
  actions: {
    getFileLink: (report, config, self) => {
      const bucket = `autotec-${getEnvironmentFromUrl()}-data-test-tool-processing`;
      let reportUrl = '';

      self.setState({ isFetching: true })

      dispatch(postCreatePresignedUrl(bucket, report, 'get', config))
        .then((result) => {
          reportUrl = result.action.payload.data.preSignedUrl;

          window.open(reportUrl, "_blank");
          self.setState({ isFetching: false });
        });
    },
  }
});

const ConnectedDataTestTool = connect(
    mapStateToProps,
    mapDispatchToProps
  )(DataTestTool);

export default withStyles(styles, { withTheme: true })(ConnectedDataTestTool);


// WEBPACK FOOTER //
// ./src/components/Account/DataTestTool.js